import {camelizeKeys, decamelizeKeys} from "humps";

export default {
  /**
   * This endpoint will validate the given NPI value (registered clinician ID).
   * @param {String} npi - The NPI value.
   * @returns {Promise<?Object>} - When successful, the NPI is valid and the result will contain clinician information.
   */
  validateNpi(npi) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/npi_validation",
        type: "POST",
        data: decamelizeKeys({ npi }),
        success: response => resolve(camelizeKeys(response)),
        error: response => reject(response.responseJSON)
      });
    });
  }
};
